import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum SlotActionName {
    SLOT_CHANGE_STATE = 'slot_change_state'
}

export class SlotAction {
    static readonly SLOT_CHANGE_STATE = new SlotAction(
        SlotActionName.SLOT_CHANGE_STATE,
        (
            <FormattedMessage
                id='SlotAction.change_state'
                description='The displayed value for the SlotAction change_state'
                defaultMessage='Change state'
            />
        )
    );

    static readonly ALL = [SlotAction.SLOT_CHANGE_STATE];

    constructor(
        public readonly value: SlotActionName | string,
        public readonly displayName: React.ReactNode
    ) {}

    static getByValue(action: string): SlotAction | undefined {
        return this.ALL.find((a) => a.value === action);
    }
}
